import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ActionButton } from '../action-button/action-button';
import { ActionButtonAppearance, ActionButtonContent, IconsEnum } from '@/shared/enums';

@Component({
  selector: 'bevvi-header',
  imports: [ActionButton],
  templateUrl: './header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Header {
  public readonly logo = input('assets/images/logo.png');
  public readonly showClose = input(true);
  public readonly borderColor = input('rgba(240, 180, 163, 0.25)');

  public readonly newChatClick = output<void>();
  public readonly closeClick = output<void>();

  protected readonly icons = IconsEnum;
  protected readonly actionButtonAppearance = ActionButtonAppearance;
  protected readonly actionButtonContent = ActionButtonContent;
}
